import React from 'react';
import { Col, ControlLabel, FormGroup, FormControl } from 'react-bootstrap';
import { Field, ErrorMessage } from 'formik';

export const Input = ({ name, type, label, col, setFieldValueOf, ...props }) => {
    return (
        <Field name={name}>
            {({ field, form: { touched, errors, setFieldValue } }) =>
                <FormGroup
                    controlId={name}
                    validationState={touched[name] && errors[name] ? 'error' : null}
                >
                    <Col componentClass={ControlLabel} sm={label.col}>
                        {label.text}
                    </Col>
                    <Col sm={col}>
                        <FormControl
                            type={type != null ? type : 'text'} 
                            {...field}
                            {...props}
                            onChange={(e) => {
                                field.onChange(e);
                                setFieldValueOf && setFieldValueOf(e, setFieldValue);
                            }}
                        />
                        <ErrorMessage
                            component="span"
                            className="text-danger"
                            name={name}
                        />
                    </Col>
                </FormGroup>
            }
        </Field>
    );
};